<fw-dialog test-id="modify-tags-dialog" width="small">
  <fw-dialog-header>
    <h3>Modify Tags</h3>
  </fw-dialog-header>
  <fw-dialog-content [formGroup]="form">
    <p>Specify what tags to add to and remove from the number selected hierarchy levels.</p>
    <fw-layout-panel border="all" [padded]="true">
      <fw-wrapped-input title="Add Tags">
        <fw-typeahead
          formControlName="addTagInput"
          maxOptionsHeight="200px"
          [allowNew]="false"
          [options]="filteredTagOptions()"
        />
      </fw-wrapped-input>
      <hr />
      <fw-wrapped-input title="Remove Tags">
        <fw-typeahead
          formControlName="removeTagInput"
          maxOptionsHeight="200px"
          [allowNew]="false"
          [options]="filteredTagOptions()"
        />
      </fw-wrapped-input>
    </fw-layout-panel>
  </fw-dialog-content>
  <fw-dialog-actions>
    <fw-button test-id="cancel" variant="outline" (click)="dialogRef.close()">Close</fw-button>
    <fw-button test-id="save" type="submit" [disabled]="!hasSelections()" (click)="submit()">Save</fw-button>
  </fw-dialog-actions>
</fw-dialog>
